import mainComponent from '@/layouts/main/Main.vue'

export default [{
  path: '/produtos',
  component: mainComponent,
  title: 'Produtos',
  children: [{
      path: '/',
      name: 'product-list',
      component: () => import('@/views/product/ProductsList.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'Produtos', active: true },
        ],
        pageTitle: 'Produtos',
        rule: 'editor'
      },
    },
    {
      path: 'estoque',
      name: 'product-stock',
      component: () => import('@/views/product/StockList.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { title: 'Home', url: '/' },
          { title: 'Produtos', url: '/produtos' },
          { title: 'Estoque', active: true },
        ],
        pageTitle: 'Estoque',
        rule: 'editor',
      },
    },
  ],
}, ];